import React from 'react';
import { useParams } from 'react-router-dom';
import PropTypes from 'prop-types';

import {
  Tab as MatTab,
  Typography as MatTypography
} from '@material-ui/core';

import { useSetState } from 'utils/hooks/useSetState';
import { UiMatTab } from './Tab.style';

/**
 * 在這邊描述這個組件
 */

const a11yProps = index => ({
  id: `simple-tab-${index}`,
  'aria-controls': `simple-tabpanel-${index}`,
});


// eslint-disable-next-line react/prop-types
const TabPanel = ({ children, tabIndex, index, ...other }) => (
  <MatTypography
    component="div"
    role="tabpanel"
    hidden={tabIndex !== index}
    id={`vertical-tabpanel-${index}`}
    aria-labelledby={`vertical-tab-${index}`}
    {...other}
  >
    {tabIndex === index && children}
  </MatTypography>
);


export const Tab = ({
  data = [],
  getTabIndex = () => { },
}) => {
  const { tab } = useParams();
  const [{ tabIndex }, setState] = useSetState({ tabIndex: tab ? parseInt(tab) : 0 });

  const tabChangeHandler = (_, tabIndex) => {
    setState({ tabIndex });
    getTabIndex(tabIndex);
  };

  return (
    <>
      <UiMatTab
        value={tabIndex}
        onChange={tabChangeHandler}
        indicatorColor="primary"
      >
        {
          data.map((item, index) => <MatTab key={index} label={item.label} {...a11yProps(index)} />)
        }
      </UiMatTab>
      {
        data.map((item, index) => {
          const { label, Component } = item;
          return (
            <TabPanel
              key={index}
              label={label}
              index={index}
              tabIndex={tabIndex}
              {...a11yProps(index)}
            >
              <Component />
            </TabPanel>
          );
        })
      }
    </>
  );
};

Tab.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      Component: PropTypes.elemennodetType
    })
  ),
  getTabIndex: PropTypes.func,
};


